import type { GenerateURL } from '@payloadcms/plugin-cloud-storage/types'
import { getWlodevFilePath } from './tools.js'

export const getGenerateURL = (): GenerateURL => {
    return ({ filename, collection }) => {
        const filePath = getWlodevFilePath(collection.slug, filename)
        return filePath
    }
}
